var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAggridColumn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5016 2.66309C12.9619 2.66309 13.335 3.03618 13.335 3.49642V12.5009C13.335 12.9611 12.9619 13.3342 12.5016 13.3342H8.83274C8.3725 13.3342 7.99941 12.9611 7.99941 12.5009L7.99941 3.49642C7.99941 3.03618 8.3725 2.66309 8.83274 2.66309L12.5016 2.66309Z",
    stroke: "#21201D",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M10.6675 2.66309V13.3342",
    stroke: "#21201D",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.49772 7.99902C4.95796 7.99902 5.33105 8.37212 5.33105 8.83236V13.1682C5.33105 13.6284 4.95796 14.0015 4.49772 14.0015H3.49661C3.03637 14.0015 2.66328 13.6284 2.66328 13.1682L2.66328 8.83236C2.66328 8.37212 3.03637 7.99902 3.49661 7.99902H4.49772Z",
    stroke: "#21201D",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M3.99795 5.99697L2.66406 4.66309",
    stroke: "#21201D",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M5.33194 4.66309L3.99805 5.99697",
    stroke: "#21201D",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    d: "M3.99753 1.99658V5.99825",
    stroke: "#21201D",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAggridColumn);
export default __webpack_public_path__ + "static/media/aggrid-column.3dd47ef4d58aca19c846c1d03a170dd5.svg";
export { ForwardRef as ReactComponent };